import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bron-page',
  templateUrl: './bron-page.component.html',
  styleUrls: ['./bron-page.component.css']
})
export class BronPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
